import { Component, input, output } from '@angular/core';

// Defaults to the "no search results" state; filters (and anything else that can empty a
// list) reuse it with their own icon/message and an optional action button.
@Component({
  selector: 'app-search-empty-state',
  templateUrl: './search-empty-state.component.html',
  styleUrl: './search-empty-state.component.scss',
  standalone: false,
})
export class SearchEmptyStateComponent {
  icon = input('search_off');
  message = input('MENU.NO_SEARCH_RESULTS');
  actionLabel = input<string | null>(null);
  action = output<void>();
}
